import React from 'react'

/**
 * Context supports dynamic localization
 */
export const LocaleContext = React.createContext({
    locale: null,
    changeLocale: () => {}
})